import { countries } from 'countries-list';

/**
 * Retourne l'indicatif telephonique international d'un pays (ex: 'FR' -> '+33').
 */
export const getDialCodeByCountryCode = (countryCode) => {
    const normalizedCountryCode = String(countryCode || '').trim().toUpperCase();
    const dialCode = countries[normalizedCountryCode]?.phone?.[0];

    return dialCode ? `+${dialCode}` : null;
};

/**
 * Insere un espace tous les 2 caracteres a partir du 2eme caractere.
 * Exemple : '669051320' -> '6 69 05 13 20'
 */
export const groupDigitsByPairs = (value) => {
    const digits = String(value || '').replace(/\D/g, '');
    if (digits.length <= 1) {
        return digits;
    }

    const [firstDigit, ...restDigits] = digits;
    const pairs = restDigits.join('').match(/\d{1,2}/g) || [];

    return [firstDigit, ...pairs].join(' ');
};

/**
 * Reconstitue un numero au format international a partir du numero brut et du countryCode.
 * Exemple : ('0669051320', 'FR') -> '+33 6 69 05 13 20'
 * Retourne null si le numero est vide.
 */
export const formatPhoneNumberWithCountryCode = (phoneNumber, countryCode) => {
    const rawPhoneNumber = String(phoneNumber || '').trim();
    if (!rawPhoneNumber) {
        return null;
    }

    const dialCode = getDialCodeByCountryCode(countryCode);
    const digits = rawPhoneNumber.replace(/\D/g, '');
    if (!digits) {
        return rawPhoneNumber;
    }

    // Numero deja international (+33... ou 0033...) : on se base sur ses propres chiffres.
    if (rawPhoneNumber.startsWith('+') || digits.startsWith('00')) {
        const internationalDigits = digits.startsWith('00') ? digits.slice(2) : digits;
        const matchingDialCode = dialCode && internationalDigits.startsWith(dialCode.slice(1))
            ? dialCode
            : null;

        if (matchingDialCode) {
            return `${matchingDialCode} ${groupDigitsByPairs(internationalDigits.slice(matchingDialCode.length - 1))}`;
        }

        return `+${internationalDigits}`;
    }

    // Pas d'indicatif exploitable : on renvoie le numero tel quel.
    if (!dialCode) {
        return rawPhoneNumber;
    }

    // Numero national : on retire le prefixe de ligne nationale (0) avant d'ajouter l'indicatif.
    const nationalDigits = digits.replace(/^0+/, '');

    return `${dialCode} ${groupDigitsByPairs(nationalDigits)}`;
};

/**
 * Construit la valeur d'un lien `tel:` (sans espace) a partir du numero et du countryCode.
 */
export const getPhoneNumberHref = (phoneNumber, countryCode) => {
    const formattedPhoneNumber = formatPhoneNumberWithCountryCode(phoneNumber, countryCode);

    return formattedPhoneNumber ? formattedPhoneNumber.replace(/\s/g, '') : null;
};
